import React from "react";

export const IconCalendar = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="calendrier">
        <path
          id="Vector (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.33203 3.33333C2.96384 3.33333 2.66536 3.63181 2.66536 4V13.3333C2.66536 13.7015 2.96384 14 3.33203 14H12.6654C13.0336 14 13.332 13.7015 13.332 13.3333V4C13.332 3.63181 13.0336 3.33333 12.6654 3.33333H3.33203ZM1.33203 4C1.33203 2.89543 2.22746 2 3.33203 2H12.6654C13.7699 2 14.6654 2.89543 14.6654 4V13.3333C14.6654 14.4379 13.7699 15.3333 12.6654 15.3333H3.33203C2.22746 15.3333 1.33203 14.4379 1.33203 13.3333V4Z"
          fill="white"
        />
        <path
          id="Vector (Stroke)_2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.6667 0.667969C11.0349 0.667969 11.3333 0.966446 11.3333 1.33464V4.0013C11.3333 4.36949 11.0349 4.66797 10.6667 4.66797C10.2985 4.66797 10 4.36949 10 4.0013V1.33464C10 0.966446 10.2985 0.667969 10.6667 0.667969Z"
          fill="white"
        />
        <path
          id="Vector (Stroke)_3"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.33464 0.667969C5.70283 0.667969 6.0013 0.966446 6.0013 1.33464V4.0013C6.0013 4.36949 5.70283 4.66797 5.33464 4.66797C4.96645 4.66797 4.66797 4.36949 4.66797 4.0013V1.33464C4.66797 0.966446 4.96645 0.667969 5.33464 0.667969Z"
          fill="white"
        />
        <path
          id="Vector (Stroke)_4"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.33203 6.66667C1.33203 6.29848 1.63051 6 1.9987 6H13.9987C14.3669 6 14.6654 6.29848 14.6654 6.66667C14.6654 7.03486 14.3669 7.33333 13.9987 7.33333H1.9987C1.63051 7.33333 1.33203 7.03486 1.33203 6.66667Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default IconCalendar;
